import { Store } from '@/core/store/core.store';
import { _COURSE_STORE } from '../enums/courses.enum';
import Course from '@/content/models/course.model';
import { IparamsComponentSelected } from '@/courses/interfaces/params-component-selected'
import { Section } from '../models/section.model';
import { MUTATIONS } from '@/classes/values/classes.values';

export class CoursesStoreFacade {

  /* Mutations */

  setEduacComponentSelected(component) {
    return Store.commit(_COURSE_STORE.EDUAC_COMPONENT_SELECTED_M, component);
  }

  setCourseInfo(course: Course) {
    return Store.commit(_COURSE_STORE.SET_COURSE_INFO_M, course);
  }

  updateOrderSections({ sections, sectionId = null , courseId , classId }) {
    return Store.commit(_COURSE_STORE.UPDATE_ORDER_SECTIONS_M, { 
      sections, sectionId, courseId , classId 
    });
  }

  updateSection({ section, courseId , classId }) {
    return Store.commit(_COURSE_STORE.UPDATE_SECTION_M, { 
      section, courseId , classId 
    });
  }

  createSection({section, parentID, copiedSectionId , courseId , classId}) {
    return Store.commit(_COURSE_STORE.CREATE_SECTION_M, { 
      section, parentID, copiedSectionId , courseId , classId 
    });
  }

  removeSection({ sectionId , courseId , classId }) {
    return Store.commit(_COURSE_STORE.REMOVE_SECTION_M, { 
      sectionId , courseId , classId 
    });
  }

  removeCourseMaterial({materialId , relatedCourseMaterials , courseId , classId}) {
    return Store.commit(_COURSE_STORE.REMOVE_COURSE_MATERIAL_M, { 
      materialId , relatedCourseMaterials , courseId , classId 
    });
  }

  removeCourseMaterialSection({sectionId, courseId, classId}) {
    return Store.commit(_COURSE_STORE.REMOVE_COURSE_MATERIAL_SECTION_M, { 
      sectionId, courseId, classId 
    });
  }

  setCourses(coursesList) {
    return Store.commit(_COURSE_STORE.SET_COURSES_M, coursesList);
  }

  setPreviewSelected({section = null, material = null, project = null, courseId , classId}) {
    return Store.commit(_COURSE_STORE.SET_PREVIEW_SELECTED_M, {
      section, material, project, courseId , classId
    });
  }

  setCourseMaterial({material , courseId, classId}) {
    return Store.commit(_COURSE_STORE.SET_COURSE_MATERIAL_M, { 
      material , courseId, classId 
    });
  }

  updateCourseMaterial({material, courseId , classId}) {
    return Store.commit(_COURSE_STORE.UPDATE_COURSE_MATERIAL_M, { 
      material, courseId , classId 
    });
  }

  setCourseMaterialSection({section, courseId , classId}) {
    return Store.commit(_COURSE_STORE.SET_COURSE_MATERIAL_SECTION_M, { 
      section, courseId , classId 
    });
  }

  setContentForCourse({data, courseId, classId}) {
    return Store.commit(_COURSE_STORE.SET_CONTENT_FOR_COURSE_M, { 
      data, courseId, classId 
    });
  }

  setTeacherOnlySection({courseId , classId ,sectionId, teacherOnly}) {
    return Store.commit(_COURSE_STORE.SET_TEACHER_ONLY_SECTION_M, { 
      courseId , classId ,sectionId, teacherOnly 
    });
  }

  updateMaterialSectionName({name, materialSectionId , courseId , classId}) {
    return Store.commit(_COURSE_STORE.UPDATE_MATERIAL_SECTION_NAME_M, { 
      name, materialSectionId , courseId , classId 
    });
  }

  setComponentSelected({courseId , classId , componentInfo}: IparamsComponentSelected) {
    return Store.commit(_COURSE_STORE.SET_COMPONENT_SELECTED_M, { 
      courseId , classId , componentInfo
    });
  }

  setCourseMode({courseId, mode}) {
    return Store.commit(_COURSE_STORE.SET_COURSE_MODE_M, { 
      courseId, mode 
    });
  }

  setMovingObject(value) {
    return Store.commit(_COURSE_STORE.SET_MOVING_OBJECT_M, 
      value
    );
  }

  setPresentationTeacherMode(data) {
    return Store.commit(_COURSE_STORE.SET_PRESENTATION_TEACHER_MODE_M,
      data
    );
  }

  setPresentationStudentMode(data) {
    return Store.commit(_COURSE_STORE.SET_PRESENTATION_STUDENT_MODE_M,
      data
    );
  }

  updatePresentationCourseSelected(data) {
    return Store.commit(_COURSE_STORE.UPDATE_PRESENTATION_COURSE_SELECTED_M,
      data
    );
  }

  setPresentationCourses({coursesList, classId}) {
    return Store.commit(_COURSE_STORE.SET_PRESENTATION_COURSES_M, {
      coursesList, classId
    });
  }

  setZoomObject(value) {
    return Store.commit(_COURSE_STORE.SET_ZOOM_OBJECT_M,
      value
    );
  }

  isSplitHorizontal(value) {
    return Store.commit(_COURSE_STORE.IS_SPLIT_HORIZONTAL_M,
      value
    );
  }

  isSplitVertical(value) {
    return Store.commit(_COURSE_STORE.IS_SPLIT_VERTICAL_M,
      value
    );
  }

  setPdfLoading(value) {
    return Store.commit(_COURSE_STORE.SET_PDF_LOADING_M,
      value
    );
  }

  setCompletedTaskBySection({persons, section}) {
    return Store.commit(_COURSE_STORE.SET_COMPLETED_TASK_BY_SECTION_M, {
      persons, section
    });
  }

  setShowSectionPersonCourseViewer(value) {
    return Store.commit(_COURSE_STORE.SET_SHOW_SECTION_PERSON_COURSE_VIEWER_M,
      value
    );
  }

  setImagesLoading(value) {
    return Store.commit(_COURSE_STORE.SET_IMAGES_LOADING_M,
      value
    );
  }

  setVideoLoading(value) {
    return Store.commit(_COURSE_STORE.SET_VIDEO_LOADING_M,
      value
    );
  }

  setGradingDetailsForCourse({gradingDetails, courseId , classId}) {
    return Store.commit(_COURSE_STORE.SET_GRADING_DETAILS_FOR_COURSE_M, {
      gradingDetails, courseId , classId
    });
  }

  createProject({project, parentId, courseId , classId}) {
    return Store.commit(_COURSE_STORE.CREATE_PROJECT_M, {
      project, parentId, courseId , classId
    });
  }

  updateProject({project, courseId , classId}) {
    return Store.commit(_COURSE_STORE.UPDATE_PROJECT_M, {
      project, courseId , classId
    });
  }

  removeProject({projectId, courseId, classId}) {
    return Store.commit(_COURSE_STORE.REMOVE_PROJECT_M, {
      projectId, courseId, classId
    });
  }

  updateOrderProjects({ projects, projectId = null, courseId, classId}) {
    return Store.commit(_COURSE_STORE.UPDATE_ORDER_PROJECTS_M, {
      projects, projectId, courseId, classId
    });
  }

  saveProjectFiles({projectId, sectionsAdded, courseId , classId, removeSections}) {
    return Store.commit(_COURSE_STORE.SAVE_PROJECT_FILES_M, {
      projectId, sectionsAdded, courseId , classId, removeSections
    });
  }

  setIsBoardSectionHomework(value) {
    return Store.commit(_COURSE_STORE.SET_IS_BOARD_SECTION_HOMEWORK_M, 
      value
    );
  }

  revertSectionMoved(data: { section: Section, nextIndex: number, nextParentId: number, currentParentId: number }) {
    return Store.commit(_COURSE_STORE.REVERT_SECTION_MOVED_M, data);
  }

  removeSectionFromParent(data: { section: Section, parentId: number }) {
    return Store.commit(_COURSE_STORE.REMOVE_SECTION_FROM_PARENT_M, data);
  }

  createDeck({deckSection , courseId , classId}) {
    return Store.commit(_COURSE_STORE.CREATE_DECK_M, {
      deckSection, courseId , classId
    });
  }

  updateDeck({deckSection, courseId , classId }) {
    return Store.commit(_COURSE_STORE.UPDATE_DECK_M, {
      deckSection, courseId , classId
    });
  }

  removeDeck({deckSectionId, courseId , classId }) {
    return Store.commit(_COURSE_STORE.REMOVE_DECK_M, {
      deckSectionId, courseId , classId
    });
  }

  refreshDeck({deckSection, courseId , classId }) {
    return Store.commit(_COURSE_STORE.REFRESH_DECK_M, {
      deckSection, courseId , classId
    });
  }

  createCard({cardSection , deckSectionId, courseId}) {
    return Store.commit(_COURSE_STORE.CREATE_CARD_M, {
      cardSection, deckSectionId, courseId
    });
  }

  updateCard({cardSection , deckSectionId, courseId}) {
    return Store.commit(_COURSE_STORE.UPDATE_CARD_M, {
      cardSection, deckSectionId, courseId
    });
  }

  removeCard({cardSectionId , deckSectionId, courseId}) {
    return Store.commit(_COURSE_STORE.REMOVE_CARD_M, {
      cardSectionId, deckSectionId, courseId
    });
  }

  setCurrentCardInfo(value) {
    return Store.commit(_COURSE_STORE.SET_CURRENT_CARD_INFO_M,
      value
    );
  }

  setCurrentMenuOptions({key, value} : {key: string, value: any}) {    
    return Store.commit(_COURSE_STORE.SET_CURRENT_MENU_OPTIONS_M,
      { key, value }
    );
  }

  resetSectionToEditM() {
    return Store.commit(_COURSE_STORE.RESET_SECTION_TO_EDIT_M);
  }

  addCourseToClassM(value) {
    return Store.commit(MUTATIONS.ADD_COURSE_TO_CLASS_M, value);
  }

  /* Actions */
  async addCourseMaterialA({material, courseId, classId}) {
    await Store.dispatch(_COURSE_STORE.ADD_COURSE_MATERIAL_A, {
      material, courseId, classId
    });
  }

  async removeCourseMaterialA(data) {
    await Store.dispatch(_COURSE_STORE.REMOVE_COURSE_MATERIAL_A, 
      data
    );
  }

  async getCourseInfoA({courseId, classId = null }) {
    return await Store.dispatch(_COURSE_STORE.GET_COURSE_INFO_A, {
      courseId, classId
    });
  }

  async getContentByEditorA({courseId, classId = null}) {
    await Store.dispatch(_COURSE_STORE.GET_CONTENT_BY_EDITOR_A, {
      courseId, classId
    });
  }

  async getContentForCourseA({courseId, classId = null}) {
    await Store.dispatch(_COURSE_STORE.GET_CONTENT_FOR_COURSE_A, {
      courseId, classId
    });
  }

  async getCoursesA({classId}) {
    return await Store.dispatch(_COURSE_STORE.GET_COURSES_A, {
      classId
    });
  }

  async removeImgFromSectionA({section, hash}) {
    return await Store.dispatch(_COURSE_STORE.REMOVE_IMG_FROM_SECTION_A, {
      section, hash
    });
  }

  async updateSectionA(section) {
    await Store.dispatch(_COURSE_STORE.UPDATE_SECTION_A, 
      section
    );
  }

  async createSectionA(payload) {
    return await Store.dispatch(_COURSE_STORE.CREATE_SECTION_A, 
      payload
    );
  }

  async reorderSectionA(payload) {
    return await Store.dispatch(_COURSE_STORE.REORDER_SECTION_A, 
      payload
    );
  }

  async removeFileA(section) {
    await Store.dispatch(_COURSE_STORE.REMOVE_FILE_A, 
      section
    );
  }

  async removeSectionA({sectionId, courseId , classId}) {
    return await Store.dispatch(_COURSE_STORE.REMOVE_SECTION_A, {
      sectionId, courseId , classId
    });
  }

  async createSectionFromObjectA(payload) {
    return await Store.dispatch(_COURSE_STORE.CREATE_SECTION_FROM_OBJECT_A, 
      payload
    );
  }

  async copySectionA({sectionID, parentID, moveSection, courseId, classId}) {
    return await Store.dispatch(_COURSE_STORE.COPY_SECTION_A, {
      sectionID, parentID, moveSection, courseId, classId
    });
  }

  async createCourseMaterialSectionA(data) {
    return await Store.dispatch(_COURSE_STORE.CREATE_COURSE_MATERIAL_SECTION_A, 
      data
    );
  }

  async updateSectionMaterialA(data) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_SECTION_MATERIAL_A, 
      data
    );
  }

  async removeSectionMaterialA({sectionId , courseId , classId}) {
    await Store.dispatch(_COURSE_STORE.REMOVE_SECTION_MATERIAL_A, {
      sectionId , courseId , classId
    });
  }

  async updateCourseMaterialSectionA({name, materialSectionId , courseId , classId}) {
    await Store.dispatch(_COURSE_STORE.UPDATE_COURSE_MATERIAL_SECTION_A, {
      name, materialSectionId , courseId , classId
    });
  }

  async moveCourseMaterialA(data) {
    return await Store.dispatch(_COURSE_STORE.MOVE_COURSE_MATERIAL_A, 
      data
    );
  }

  async moveCourseMaterialSectionA(data) {
    return await Store.dispatch(_COURSE_STORE.MOVE_COURSE_MATERIAL_SECTION_A, 
      data
    );
  }

  async createWriteObjectA({payload, courseId, parentId}) {
    return await Store.dispatch(_COURSE_STORE.CREATE_WRITE_OBJECT_A, {
      payload, courseId, parentId
    });
  }

  async updateWriteObjectA({payload, courseId, parentId, sectionId}) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_WRITE_OBJECT_A, {
      payload, courseId, parentId, sectionId
    });
  }

  async updateCourseMaterialA({data, courseId}) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_COURSE_MATERIAL_A, {
      data, courseId
    });
  }

  async updateSectionMaterialVisibilityA({sectionId, teacherOnly, courseId, saveMessageTeacherOnly}) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_SECTION_MATERIAL_VISIBILITY_A, {
      sectionId, teacherOnly, courseId, saveMessageTeacherOnly
    });
  }

  async updateCourseFilesIfInfoReadyA(data) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_COURSE_FILES_INFO_READY_A, 
      data
    );
  }

  async updateCourseMaterialIfInfoReadyA(data) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_COURSE_MATERIAL_INFO_READY_A, 
      data
    );
  }

  async updateFileA(payload) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_FILE_A, 
      payload
    );
  }

  async rotateContentAssetA(payload: {courseId:number, sectionId:number, rotatePageList:{page:number,rotateDegrees:number}[]}) {
    return await Store.dispatch(_COURSE_STORE.ROTATE_CONTENT_ASSET_A, payload);
  }

  async setTeacherOnlySectionA({sectionId, courseId, teacherOnly, classId }) {
    return await Store.dispatch(_COURSE_STORE.SET_TEACHER_ONLY_SECTION_A, {
      sectionId, courseId, teacherOnly, classId 
    });
  }

  async getPresentationCoursesA({classId}) {
    return await Store.dispatch(_COURSE_STORE.GET_PRESENTATION_COURSES_A, {
      classId 
    });
  }

  async getCompletedTaskByStudentA({sectionId, courseId, classId, page = 0}) {
    return await Store.dispatch(_COURSE_STORE.GET_COMPLETED_TASK_BY_STUDENT_A, {
      sectionId, courseId, classId, page
    });
  }

  async getGradingDetailsForCourseA({courseId , classId = null}) {
    return await Store.dispatch(_COURSE_STORE.GET_GRADING_DETAILS_FOR_COURSE_A, {
      courseId , classId
    });
  }

  async createProjectA(payload) {
    return await Store.dispatch(_COURSE_STORE.CREATE_PROJECT_A,
      payload
    );
  }

  async updateProjectA(payload) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_PROJECT_A,
      payload
    );
  }

  async removeProjectA({projectId, courseId, classId}) {
    return await Store.dispatch(_COURSE_STORE.REMOVE_PROJECT_A, {
      projectId, courseId, classId
    });
  }

  async reorderProjectA({project, parentId, place, courseId}) {
    return await Store.dispatch(_COURSE_STORE.REORDER_PROJECT_A, {
      project, parentId, place, courseId
    });
  }

  async saveProjectFilesA({parentId, courseId, classId, addSections, removeSections}) {
    return await Store.dispatch(_COURSE_STORE.SAVE_PROJECT_FILES_A, {
      parentId, courseId, classId, addSections, removeSections
    });
  }

  async getCourseEditionA(courseId) {
    return await Store.dispatch(_COURSE_STORE.GET_COURSE_EDITION_A, 
      courseId
    );
  }

  createComponent(payload) {
    return Store.dispatch(_COURSE_STORE.CREATE_EDUAC_COMPONENT,
      payload
    );
  }

  updateComponent(payload) {
    return Store.dispatch(_COURSE_STORE.UPDATE_EDUAC_COMPONENT,
      payload
    );
  }

  removeComponent(payload) {
    return Store.dispatch(_COURSE_STORE.REMOVE_EDUAC_COMPONENT,
      payload
    );
  }

  addComponent(payload) {
    return Store.commit(_COURSE_STORE.ADD_EDUAC_COMPONENT, payload);
  }

  setComponent(payload) {
    return Store.commit(_COURSE_STORE.SET_EDUAC_COMPONENT, payload);
  }

  deleteComponent(payload) {
    return Store.commit(_COURSE_STORE.DELETE_EDUAC_COMPONENT, payload);
  }

  async createDeckA(payload) {
    return await Store.dispatch(_COURSE_STORE.CREATE_DECK_A, payload);
  }

  async updateDeckA(payload) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_DECK_A, payload);
  }

  async removeDeckA(payload) {
    return await Store.dispatch(_COURSE_STORE.REMOVE_DECK_A, payload);
  }

  async refreshDeckA(payload) {
    return await Store.dispatch(_COURSE_STORE.REFRESH_DECK_A, payload);
  }

  async refreshSectionStructureA(payload) {
    return await Store.dispatch(_COURSE_STORE.REFRESH_SECTIOM_STRUCTURE_A, payload);
  }

  async createCardA(payload) {
    return await Store.dispatch(_COURSE_STORE.CREATE_CARD_A, payload);
  }

  async updateCardA(payload) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_CARD_A, payload);
  }

  async moveCardA(payload) {
    return await Store.dispatch(_COURSE_STORE.MOVE_CARD_A, payload);
  }

  async removeCardA(payload) {
    return await Store.dispatch(_COURSE_STORE.REMOVE_CARD_A, payload);
  }

  async createSubDeckA(payload) {
    return await Store.dispatch(_COURSE_STORE.CREATE_SUB_DECK_A, payload);
  }

  async updateSubDeckA(payload) {
    return await Store.dispatch(_COURSE_STORE.UPDATE_SUB_DECK_A, payload);
  }

}